<!--
 * @Description: 
 * @Author: 李方强
 * @Date: 2020-03-16 10:59:16
 * @LastEditTime: 2021-12-16 14:07:36
 * @LastEditors: lkz
 -->
<template>
  <div id="card-detail-template">
    

    <!-- 订单模块 -->
    <div v-show="getIsShow(['1'], sopWorkFlowDetail.showType)" :class="(sopWorkFlowDetail.ifReSelect === 1 || sopWorkFlowDetail.checkedId) && !isType ? 'order-select' : ''">
        <div style="display:flow;">
          <!-- <span class="block" v-html="item.interactionDesc"></span> -->
          <div style="padding: 0 0 5px;">
            <span class="block">请选择订单</span>
            <el-tooltip class="item" effect="dark" placement="top-start" v-if="sopWorkFlowDetail.logicalDesc">
              <div slot="content" v-html="toHtml(sopWorkFlowDetail.logicalDesc)"></div>
              &nbsp;<i class="el-icon-warning-outline"></i>
            </el-tooltip>
            &nbsp;<el-link type="primary" v-show="sopWorkFlowDetail.ifReSelect === 1" @click="reselection">重选</el-link> 
          <!-- 推荐话术组件 -->  
            <recommend-word-detail :recommendList="sopWorkFlowDetail.recommendWordList" :sopDetailList="sopDetailList" :sopChannel="sopChannel"></recommend-word-detail>
          </div>
        </div>
      <div 
        style="min-width: 225px"
        :class="{ 'cardContent' : isType, 'detailsCardContent':true}"
        v-for="(item1, index1) in sopWorkFlowDetail.orderData" 
        :key="index1" 
        @click="getInvoices(sopWorkFlowDetail, 1, item1.orderId)"
        v-show="!item1.showflg">
        <div class="contentWarp" v-for="(item2, index2) in item1.itemDataList.filter((item,index) => index === 0)" :key="index2">
          <img class="card-img" :src="item2.itemImg" alt="">
          <div class="content-right" v-if="!sopWorkFlowDetail.checkedId && (sopWorkFlowDetail.ifReSelect === 0  && !isType) || isType">
            <el-tooltip popper-class="tooltip_width" :content="item2.itemName.toString()" placement="top">
              <p>{{item2.itemName}}</p>
            </el-tooltip>
            <p><span class="content-num">X{{item2.buyCount}}</span></p>
            <p class="commodity-money">¥{{item2.itemPrice}}</p>
          </div>
        </div>
        <div class="content-absolute">
          <el-tooltip popper-class="tooltip_width" :content="item1.orderId.toString()" placement="top">
            <p class="absolute-order content-hide" v-if="isType">
              <span>订单:</span>{{item1.orderId}}
            </p>
            <p class="absolute-order content-hide" v-if="(sopWorkFlowDetail.checkedId || (sopWorkFlowDetail.ifReSelect === 1 )) && !isType">
              {{item1.itemDataList[0].itemName}}
            </p>
          </el-tooltip>
          <p class="card-staus">{{item1.orderStatus}}</p>
          <p>实付支付：<span class="card-money">¥{{item1.payMoney}}</span></p>
        </div>
      </div>
    </div>
    <!-- 售后单模块 -->
    <div v-show="getIsShow(['3'], sopWorkFlowDetail.showType)" :class="(sopWorkFlowDetail.ifReSelect === 1 || sopWorkFlowDetail.checkedId) && !isType ? 'returns-select' : ''">
        <div style="display:flow;">
          <!-- <span class="block" v-html="item.interactionDesc"></span> -->
          <div style="padding: 0 0 5px;">
            <span class="block">请选择售后单</span>
            <el-tooltip class="item" effect="dark" placement="top-start" v-if="sopWorkFlowDetail.logicalDesc">
              <div slot="content" v-html="toHtml(sopWorkFlowDetail.logicalDesc)"></div>
              &nbsp;<i class="el-icon-warning-outline"></i>
            </el-tooltip>
            &nbsp;<el-link type="primary" v-show="sopWorkFlowDetail.ifReSelect === 1" @click="reselection">重选</el-link> 
          <!-- 推荐话术组件 -->  
            <recommend-word-detail :recommendList="sopWorkFlowDetail.recommendWordList" :sopDetailList="sopDetailList" :sopChannel="sopChannel"></recommend-word-detail>
          </div>
        </div>
      <div 
        style="min-width: 225px"
        :class="{ 'cardContent' : isType, 'detailsCardContent': true}"
        v-for="(item1, index1) in sopWorkFlowDetail.orderRefundData" 
        :key="index1" 
        @click="getInvoices(sopWorkFlowDetail, 3, item1.returnId)"
        v-show="!item1.showflg">
        <div class="contentWarp">
          <img class="card-img" :src="item1.itemData.itemImg" alt="">
          <div class="content-right" v-if="!sopWorkFlowDetail.checkedId && (sopWorkFlowDetail.ifReSelect === 0  && !isType) || isType">
            <el-tooltip popper-class="tooltip_width" :content="item1.itemData.itemName.toString()" placement="top">
              <p>{{item1.itemData.itemName}}</p>
            </el-tooltip>
            <p><span>¥{{item1.returnMoney}}</span><span class="content-num">X{{item1.itemData.buyCount}}</span></p>
            <p class="commodity-color content-hide">规格: {{item1.itemData.itemModel}}</p>
          </div>
        </div>
        <div class="content-absolute">
          <el-tooltip popper-class="tooltip_width" :content="item1.returnId.toString()" placement="top">
            <p class="absolute-order content-hide"><span>售后:</span>{{item1.returnId}}</p>
          </el-tooltip>
          <p class="content-hide">{{item1.refundStatus}}</p>
          <p class="card-staus content-hide">{{item1.refundType}}</p>
        </div>
      </div>
    </div>
    <!-- 商品模块 -->
    <div v-show="getIsShow(['4'], sopWorkFlowDetail.showType)" class="card-item"  >
      <div style="display:flow;">
          <!-- <span class="block" v-html="item.interactionDesc"></span> -->
          <div style="padding: 0 0 5px;">
            <span class="block">请选择商品</span>
            <el-tooltip class="item" effect="dark" placement="top-start" v-if="sopWorkFlowDetail.logicalDesc">
              <div slot="content" v-html="toHtml(sopWorkFlowDetail.logicalDesc)"></div>
              &nbsp;<i class="el-icon-warning-outline"></i>
            </el-tooltip>
            &nbsp;<el-link type="primary" v-show="sopWorkFlowDetail.ifReSelect === 1" @click="reselection">重选</el-link> 
          <!-- 推荐话术组件 -->  
            <recommend-word-detail :recommendList="sopWorkFlowDetail.recommendWordList" :sopDetailList="sopDetailList" :sopChannel="sopChannel"></recommend-word-detail>
          </div>
        </div>
      <div class="flex-item-card" :class="{'flex-item-card-isType': isType}" style="width:100%">
        <!-- <p v-if="sopWorkFlowDetail.ifReSelect === 1 || sopWorkFlowDetail.checkedId">用户咨询商品</p> -->
        <div 
          style="min-width: 225px;"
          class="detailItemCard"
          v-for="(item1, index1) in sopWorkFlowDetail.itemData" 
          :key="index1"  
          v-show="!item1.showflg">
          
          <div class="contentWarp" :class="(sopWorkFlowDetail.ifReSelect === 1 || item1.itemId == sopWorkFlowDetail.checkedId) ? 'isSelect' : ''" 
          @click="(sopWorkFlowDetail.ifReSelect === 1 || item1.itemId == sopWorkFlowDetail.checkedId)?reselection():getInvoices(sopWorkFlowDetail, 4, item1.itemId)" >
            <img class="card-img" :src="item1.itemImg" alt="">
            <div class="content-right">
              <p class="content-hide" style="margin-top: 7px;">{{item1.itemName}} </p>
              <p class="commodity-color" style="width: 100%">{{item1.itemModel}}</p>
              <p class="commodity-money" style="width: 100%;">¥
                <span style="color: #F10D3B">{{item1.itemPrice}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 子单模块 -->
    <div v-if="getIsShow(['5'], sopWorkFlowDetail.showType)" class="sub-orderid">
      <!-- <p class="card-title"
      v-if="sopWorkFlowDetail.ifReSelect === 0 && !sopWorkFlowDetail.checkedId"
      >
        <el-tooltip popper-class="tooltip_width" :content="filter.creaHtml(sopWorkFlowDetail.interactionDesc)" placement="top">
          <span 
            class="card-title-explain"
            v-if="sopWorkFlowDetail.ifReSelect === 0 && sopWorkFlowDetail.subOrderData" 
            v-html=$xss(sopWorkFlowDetail.interactionDesc)>
          </span>
        </el-tooltip> 
      </p> -->
      
      <div style="display:flow;">
          <!-- <span class="block" v-html="item.interactionDesc"></span> -->
          <div style="padding: 0 0 5px;">
            <span class="block">请选择子订单</span>
            <el-tooltip class="item" effect="dark" placement="top-start" v-if="sopWorkFlowDetail.logicalDesc" >
              <div slot="content" v-html="toHtml(sopWorkFlowDetail.logicalDesc)"></div>
              &nbsp;<i class="el-icon-warning-outline"></i>
            </el-tooltip>
            &nbsp;<el-link type="primary" v-show="sopWorkFlowDetail.ifReSelect === 1" @click="reselectionOrder">重选</el-link> 
          <!-- 推荐话术组件 -->  
            <recommend-word-detail :recommendList="sopWorkFlowDetail.recommendWordList" :sopDetailList="sopDetailList" :sopChannel="sopChannel"></recommend-word-detail>
          </div>
        </div>
      <div v-show="!treeSelect">
        <el-tree
          v-if="sopWorkFlowDetail.subOrderData"
          class="el-tree-card"
          default-expand-all
          :expand-on-click-node="false"
          :check-strictly="true"
          ref="tree"
          node-key="subOrderId"
          :data="sopWorkFlowDetail.subOrderData"
          :props="props"
          show-checkbox
          :check-on-click-node="false"
          @check-change="handleCheckChange"
          :render-content="renderContent"
          @node-click="handleCheck"
          @check="handleCheck"
        >
        </el-tree>
      </div>
      <div v-show="treeSelect" :class=" {'tree-select': !isType}">
          <!-- <div class="card-title-new" v-if="!isType">用户咨询子单</div>
        <span class="pack-up pack-up-select" @click="reselectionOrder">重选</span> -->
        <div 
          style="min-width: 225px"
          :class="{ 'cardContent' : isType, 'detailsCardContent': true}" @click="reselectionOrder">
          <div class="contentWarp">
            <img class="card-img" :src="treeObj.itemImg" alt="">
            <div class="content-right" style="width:160px;">
              <p style="margin-top: 7px;">{{treeObj.itemName}}</p>
              <p class="flex">
                <span>{{treeObj.itemModel}}</span>
                <span v-if="treeObj.buyCount">x{{treeObj.buyCount}}</span>
              </p>
              <p>¥{{treeObj.itemPrice}}</p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import * as filter from '@core/filters'
import { mapState } from 'vuex'
import recommendWordDetail from './recommendWordDetail'

export default {
  components: {
    recommendWordDetail
  },
  props: {
    // 入口类型 true:缩略版sop false:详情版sop
    isType: {
      type: Boolean
    },
    // 把上一次出参保存
    sopWorkFlowDetail: {
      type: Object
    },
    sopDetailList: Object,
    sopChannel: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      arrlist: state => state.work.arrlist,
      index: state => state.work.index,
      topfont: state => state.work.topfont,
      nowlist: state => state.work.nowlist,
      empIds: state => state.work.empIds,
      oldnow: state => state.work.oldnow,
      oldflg: state => state.work.oldflg,
      oldlist: state => state.work.oldlist,
      oldIndex: state => state.work.oldIndex,
      serviceOption: state => state.work.serviceOption
    })
  },  
  data() {
    return {
      filter,
      props: {
        label: 'itemName',
        children: 'tuDetails'
      },
      treeSelect: false,
      treeObj: {}
    }
  },
  watch: {
    'sopWorkFlowDetail.subOrderData'(val) {
      if (val) {
        this.$nextTick(() => {
          if (val && this.sopWorkFlowDetail.checkedId && this.sopWorkFlowDetail.subOrderData 
            && this.sopWorkFlowDetail.subOrderData.length && this.sopWorkFlowDetail.showType === '5') {
            this.treeSelect = true
            const item = this.getDefaultSubOrderData(this.sopWorkFlowDetail.subOrderData, this.sopWorkFlowDetail.checkedId)
            this.treeObj = item
          } else {
            this.treeObj = {}
            this.treeSelect = false
          }
        })
      } else {
        this.treeObj = {}
        this.treeSelect = false
      }
    }
  },
  mounted() {
    // console.log('mounted', this.sopWorkFlowDetail)
    if (this.sopWorkFlowDetail.checkedId && this.sopWorkFlowDetail.subOrderData && this.sopWorkFlowDetail.subOrderData.length && this.sopWorkFlowDetail.showType === '5') {
      this.treeSelect = true
      const item = this.getDefaultSubOrderData(this.sopWorkFlowDetail.subOrderData, this.sopWorkFlowDetail.checkedId)
      this.treeObj = item
    }
  },
  methods: {
    // 递归获取item
    getDefaultSubOrderData(sop, id) {
      let i = {}
      for (let k = 0; k < sop.length; k++) {
        const item = sop[k]
        if (item.subOrderId === id) {
          i = item
          console.log('getDefaultSubOrderData', item)
          break
        }
        if (item.tuDetails) {
          i = this.getDefaultSubOrderData(item.tuDetails, id)
          if (i.itemName) break
        }
      }
      return i 
    },
    // 判断当前sop是否展示
    getIsShow(arr, arr2) {
      if (typeof arr2 === 'object') {
        arr2 = ''
      } else if (typeof arr2 === 'number') {
        arr2 = arr2.toString()
      }
      let isShow = false
      const num = arr2.split(',')
      arr.forEach((i) => {
        if (num.indexOf(i) !== -1) {
          isShow = true
        }
      })
      return isShow
    },
    // 选中单据
    getInvoices(item, type, id) {
      if ((item.itemData && item.itemData.length === 1) 
        || (item.orderData && item.orderData.length === 1) 
        || (item.orderRefundData && item.orderRefundData.length === 1)
      ) {
        // return
      }
      const data = {
        item: item,
        type: type,
        id: id
      }
      this.$emit('getCheckInvoices', data)
      if (this.sopChannel === 1) {
        try {
          const newstart = JSON.parse(JSON.stringify(this.nowlist))
          window.thinkingReport.track('others', {
            page_id: '81120',
            point_id: '29686',
            content_type: type,
            content_name: id,
            operation_name: '选择器选中',
            component_id: this.sopDetailList.sopId,
            job_num: this.empIds.empId,
            source_content_id: newstart.sessionId,
            order_id: `${this.sopDetailList.targetId}|${this.sopDetailList.targetContent}`
          })
        } catch (e) {
          console.log(e)
        }
      }
    },
    // 点击重选
    reselection() {
      // num = 1:商品 2：订单  3：售后单 4：自定义菜单
      let num = 0
      // 标识目前重选的是第几个
      if (this.sopWorkFlowDetail.itemData) {
        num = this.sopWorkFlowDetail.itemData[0].itemId
      } else if (this.sopWorkFlowDetail.orderData) {
        num = this.sopWorkFlowDetail.orderData[0].orderId
      } else if (this.sopWorkFlowDetail.orderRefundData) {
        num = this.sopWorkFlowDetail.orderRefundData[0].returnId
      }
      this.$emit('getReselection', num)
    },
    // 点击收起
    packUp() {
      // num = 1:商品 2：订单  3：售后单 4：自定义菜单
      let num = ''
      // 标识目前重选的是第几个
      if (this.sopWorkFlowDetail.itemData) {
        num = this.sopWorkFlowDetail.itemData[0].itemId
      } else if (this.sopWorkFlowDetail.orderData) {
        num = this.sopWorkFlowDetail.orderData[0].orderId
      } else if (this.sopWorkFlowDetail.orderRefundData) {
        num = this.sopWorkFlowDetail.orderRefundData[0].returnId
      }
      this.$emit('getPackUp', num)
    },
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate)
      // console.log(this.$refs.tree.getCheckedNodes())
      // const newdata = JSON.parse(JSON.stringify(data))
      // this.$nextTick(() => {
      //   this.$refs.tree.setCheckedKeys([])
      //   this.$refs.tree.setCheckedKeys([newdata.subOrderId])
      // })
      
      // if (checked) {
      //   this.$refs.tree.setCheckedKeys([data.subOrderId])
      //   this.getInvoices(this.sopWorkFlowDetail, 5, data.subOrderId)
      // } else {
      //   this.$refs.tree.setCheckedKeys([])
      // }
    },
    nodeClick(data, node, component) {
      // this.$refs.tree.setCheckedKeys([data.subOrderId])
      // this.getInvoices(this.sopWorkFlowDetail, 5, data.subOrderId)
    },
    handleCheck(data, obj) {
      // console.log(data, obj)
      // console.log('选中')
      this.treeSelect = true
      this.treeObj = data
      this.$refs.tree.setCheckedKeys([data.subOrderId])
      this.getInvoices(this.sopWorkFlowDetail, 5, data.subOrderId)
      // console.log(this.$refs.tree.getCheckedKeys())
      // console.log(data, obj)
    },
    renderContent(h, { node, data, store }) {
      // <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
      // <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
      // <i icon-class class="icon-class"></i>
      return (
        <div class="custom-tree-node">
          <img class="custom-tree-node-img" src={node.data.itemImg}/>
          <span class="flex-span">
            <span>{node.data.itemName}</span>
            <span>{node.data.itemModel}</span>
            <span>¥{node.data.itemPrice}</span>
          </span>
        </div>)
    },
    getCurrentKey(data, node) {
      console.log(data, node)
    },
    cleanTree() {
      if (this.$refs.tree) this.$refs.tree.setCheckedKeys([])
    },
    reselectionOrder() {
      this.treeObj = {}
      this.treeSelect = false
      this.$refs.tree.setCheckedKeys([])
    },
    filterHtml(html) {
      return html.replace(/<\/?.+?\/?>/g, '')
    },
    toHtml(txt) {
      return txt.replace(/[\n]/g, '<br/>')
    }
  }
}
</script>
<style lang="less">
  #card-detail-template {
    position: relative;
    padding: 5px;
    background: #fff;
    .card-title {
      margin: 0 60px 0 0;
      // padding: 16px 12px;
      color: #333;
      .card-title-explain {
        overflow:hidden; 
        text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2; 
        /deep/ p {
          margin: 0;
        }
      }
    }
    .card-title-new {
      padding: 12px 0;
    }
    .flex {
      display: flex;
      justify-content: space-between;
    }
    .pt-20 {
      padding-top: 20px
    }
    .pack-up {
      position: absolute;
      right: 12px;
      top: 12px;
      color: #409EFF;
      cursor: pointer;
      margin-bottom: 10px;
      z-index: 999;
    }
    // .pack-up-select {
    //   bottom: 10px;
    //   right: 23px;
    // }
    .cardContent {
      padding: 10px 12px;
      position: relative;
      border-bottom: 1px solid #F2F5F7;
      .contentWarp {
        width: 100%;
        display: flex;
        .card-img {
          height: 48px;
          width: 48px;
          border-radius: 4px;
          margin-right: 8px;
        }
        .content-right {
          flex: 1;
          p {
            margin: 0 0 1px;
            font-size: 12px;
            line-height: normal;
            color: #333333;
            min-width: 100px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            .content-num {
              color: #999;
            }
            .content_shop_num {
              float: right;
              color: #999;
              padding-left: 5px;
            }
          }
          .commodity-color {
            color: #999;
          }
        }
      }
      .content-absolute {
        position: absolute;
        right: 12px;
        top: 10px;
        p {
          margin: 0 0 1px;
          text-align: right;
        }
        .absolute-order {
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .card-staus {
          color: #F10D3B;
        }
      }
    }
    .cardContent:hover {
      cursor: pointer;
      background: rgba(64,158,255,0.08);
    }
    .detailsCardContent, .detailItemCard {
      padding: 0;
      // display: flex;
      position: relative;
      border-bottom: 1px solid #F2F5F7;
      border: 1px solid #E3E6E8;
      // box-shadow: 0px 2px 4px 0px #ccc;
      // -moz-box-shadow: 0px 2px 4px 0px #ccc;
      // -webkit-box-shadow: 0px 2px 4px 0px #ccc;
      .contentWarp {
        overflow: hidden;
        display: flex;
        .card-img {
          height: 72px;
          width: 72px;
          flex: 0 0 72px;
          border-radius: 4px;
          margin-right: 8px;
          float: left;
        }
        .content-right {
          // width: 100px;
          flex: 1;
          margin-right: 10px;
          display: inline-block;
          // right: 10px;
          p {
            margin: 0;
            min-width: 100px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            .content-num {
              color: #999;
            }
          }
          .commodity-money {
            margin-top: 13px;
            color: #333;
            font-size: 12px;
          }
          .commodity-color {
            color: #999;
          }
        }
      }
      .content-absolute {
        position: absolute;
        right: 6px;
        top: 0px;
        p {
          text-align: right;
          margin: 0;
          .card-money {
            font-size: 16px;
            color: #F10D3B;
          }
        }
      }
      .card-reelect {
        position: absolute;
        right: -44px;
        top: 34px;
        cursor: pointer;
        color: #409EFF;
      }
    }
    .detailItemCard {
      // flex: 1;
      // width: 210px;
      margin: 10px 0;
      .contentWarp {
        width: 185px;
        .content-right {
          // position: absolute;
        }
      }
      .isSelect {
        max-width: 450px;
      }
    }
    
    .detailsCardContent:hover {
      cursor: pointer;
      background: rgba(64,158,255,0.08);
    }
  }
  .tooltip_width {
    max-width: 300px;
  }
</style>
<style lang="less" scoped>
.flex-item-card {
  display: inline-block;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 60px 10px 17px;
  /deep/.card-title-select {
    // display: inline-block;
    // width: 101px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // vertical-align: bottom;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    width: 130px;
  }
}
.flex-item-card-isType {
  padding: 0 0;
}
/deep/.custom-tree-node {
  display: flex;
  position: relative;
  .custom-tree-node-img {
    width: 80px;
    height: 80px;
  }
}

/deep/.el-tree-node__content {
  height: unset;
  .flex-span {
    display: flex;
    line-height: normal;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
    span {
      min-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.el-tree-card {
  /deep/.icon-class {
    width: 12px;
    height: 12px;
    // background-color: #000;
    position: absolute;
    top: 33px;
    left: -21px;
    z-index: 666;
  }
}
.sub-orderid {
  .modal-tree {
    height: 100%;
    width: 80px;
    position: absolute;
    top: 0;
    left: 23px;
    z-index: 666;
  }
}
.returns-select {
  display: flex;
  align-items: center;
  padding: 10px 60px 10px 17px;
  // border: 1px solid #ccc;
  justify-content: space-between;
  /deep/.card-title-explain {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1!important;
    width: 101px;
    span {
      display: inline-block;
      width: 101px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: bottom;
    }
  }
}

.order-select {
  display: flex;
  align-items: center;
  padding: 10px 60px 10px 17px;
  margin-top: 15px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  /deep/.card-title-explain {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1!important;
    width: 101px;
    span {
      display: inline-block;
      width: 101px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: bottom;
    }
  }
}
.tree-select {
  display: flex;
  align-items: center;
  padding: 10px 60px 10px 17px;
  justify-content: space-between;
}

.content-hide {
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.top10 {
  margin-top: 10px;
}
</style>
